export const API_ROUTES = {
    AUTH: {
        LOGIN: "/v1/login",
        LOGIN_GOOGLE: "/v1/login/google",
        REGISTER: "/v1/sign_up",
        REFRESH: "/v1/refresh",
        VERIFY_EMAIL: "/v1/verification",
        RESEND_VERIFICATION: "/v1/resend-verification",
        FORGOT_PASSWORD: "/v1/forgot-password",
        SEND_FORGOT_PASSWORD_EMAIL: "/v1/send-forgot-password-email",
        CONFIRM_FORGOT_PASSWORD: "/v1/confirm-forgot-password",
    },
    PERSONS: {
        PERSONA: "/v1/personas",
    },
    SOPORTE: {
        BUGS: "/v1/soporte/bugs",
    }
};